'use client';

import { Suspense } from 'react';
import { PlashkaPriglasheniya } from '@/components/aisearch/partneram/plashka-priglasheniya';
import { useTranslations } from 'next-intl';
import { ShapkaVhoda } from '@/components/features/shapka-vhoda';
import { useSearchParams } from 'next/navigation';
import { UserPlus } from 'lucide-react';
import { Link } from '@/i18n/routing';
import { FlowForm } from '@/components/features/flow-form';
import { VhodYandex } from '@/components/features/vhod-yandex';
import { putVozvrata } from '@/lib/vozvrat-posle-vhoda';

function RegisterCard() {
  const t = useTranslations('register');
  const tl = useTranslations('login');
  const searchParams = useSearchParams();
  const syroj = searchParams.get('callbackUrl');
  // Только свой путь: см. login/page.tsx.
  const callbackUrl = putVozvrata(syroj);

  return (
    <div className="w-full max-w-md">
      <div className="bg-[var(--color-bg-card)] border border-[var(--color-border)] rounded-2xl p-8 shadow-xl">
        <div className="text-center mb-8">
          <ShapkaVhoda znachok={<UserPlus className="w-6 h-6 text-[var(--color-brand-400)]" />} />
          <p className="text-[var(--color-text-muted)]">{t('subtitle')}</p>
        </div>

        <FlowForm kind="enrollment" callbackUrl={callbackUrl} />

        {/* Через Яндекс регистрация и вход одно и то же: новый аккаунт заводится сам. */}
        <VhodYandex callbackUrl={callbackUrl} />

        <div className="mt-6 pt-6 border-t border-[var(--color-border)] text-center text-sm">
          <p className="text-[var(--color-text-muted)]">
            {t('have_account')}{' '}
            <Link
              href={syroj ? { pathname: '/login', query: { callbackUrl } } : '/login'}
              className="text-[var(--color-accent-400)] hover:underline"
            >
              {tl('submit')}
            </Link>
          </p>
        </div>

        <p className="text-xs text-[var(--color-text-muted)] text-center mt-6">{tl('footer')}</p>
      </div>
    </div>
  );
}

export default function RegisterPage() {
  return (
    <main className="min-h-[calc(100vh-4rem)] flex flex-col items-center justify-center p-8">
      {/* Только aisearch.ru, по метке приглашения и при включённой программе. */}
      <PlashkaPriglasheniya />
      <Suspense fallback={null}>
        <RegisterCard />
      </Suspense>
    </main>
  );
}
